// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"24ad3ad7","338":"27df80e7","379":"b5c77b5c","626":"6e417454","668":"5f224768"}[chunkId] + ".chunk.js";
};